import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getCookie } from 'shared/utils/cookie';

import { DeviceList } from 'web/components/common/modal';
import { postListItemNameRequest } from 'shared/actions/modal.action';

import storage from 'shared/utils/storage';

import {
  postUserDeviceRequest,
  deleteUserDeviceRequest,
} from 'shared/actions/auth.action';

@withRouter
@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  { postUserDeviceRequest, deleteUserDeviceRequest, postListItemNameRequest },
)
class DeviceListContainer extends Component {
  state = {
    selectItem: null, // idx
  };

  handleModify = (id, name, i) => {
    // console.log('DeviceListContainer - handleModify', name);
    this.props.postListItemNameRequest(id, name, i);
  };

  handleSelect = idx => {
    this.setState({
      selectItem: idx,
    });
  };

  handleSubmit = e => {
    // console.log(`handleSubmit`);
    e.preventDefault();

    const { selectItem } = this.state;
    const { modal = {} } = this.props;
    const { data = {} } = modal;
    const { list = [], token = {} } = data;
    const target = list[selectItem];
    const access_token = token.access_token || storage.get('access_token');
    const refresh_token = token.refresh_token || storage.get('refresh_token');

    // // console.log({ token, target, list, selectItem });
    if (!(access_token && refresh_token && target?.id)) {
      return;
    }

    const dr_refresh_token = getCookie('dr_refresh_token');

    let postData = {
      access_token,
      refresh_token: refresh_token || dr_refresh_token,
      id: target.id,
    };

    console.log({ handleSubmit: modal, postData });

    return this.props.postUserDeviceRequest(token, target.id);
  };

  handleDeleteItem = idx => {
    // console.log(`handleDeleteItem`);

    const { modal = {} } = this.props;
    const { data = {} } = modal;
    const { list = [], token = {} } = data;
    const target = list[idx];

    if (!(token.access_token && target.id)) {
      // console.log(token.access_token, target.id, '정보가 부족합니다.');
      return;
    }

    return this.props.deleteUserDeviceRequest(token, target.id);
  };

  render() {
    const { selectItem } = this.state;
    const { modal = {} } = this.props;
    const { data = {} } = modal;
    const { list = [] } = data;

    return (
      <DeviceList
        isController={data.isController}
        list={list}
        selectItem={selectItem}
        handleSelect={this.handleSelect}
        handleDeleteItem={this.handleDeleteItem}
        handleSubmit={this.handleSubmit}
        handlePopup={this.props.popupHandler}
        handleModify={this.handleModify}
      />
    );
  }
}

export default DeviceListContainer;
